import React, { useState } from 'react';
import Header from '../../../../components/Table/Header';
import Cell from '../../../../components/Cell';
import Table from '../../../../components/Table';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const TotalRow = styled.div`
  background-color: #2b3d54;
  color: white;
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-weight: 600;
  font-size: 12px;

  .labelPosRecapTotal {
    width: 56%;
  }

  .labelPosRecapTotal p {
    margin-left: 30px;
  }

  .won {
    color: #6cc89f;
    width: 22%;
    text-align: center;
  }

  .lost {
    color: ${(props) => props.theme.colors['terra-cotta']};
    width: 22%;
    text-align: center;
  }
`;

const PosRecap = ({ data = [], isBranded, total }) => {
  const [sorted, setSorted] = useState([]);
  const [expanded, setExpanded] = useState({});

  const handleSort = (id) => {
    let newSorted = [...sorted];
    let desc = true;
    if (newSorted.length > 0 && newSorted[0].id === id) {
      desc = !newSorted[0].desc;
    }
    newSorted = [{ id, desc }];
    setSorted(newSorted);
    setExpanded({});
  };

  const handleExpanded = (index) => {
    const newExpanded = { ...expanded };
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  const columns = [
    {
      accessor: 'wine',
      Header: () => (
        <Header
          sortable={true}
          sort={() => handleSort('wine')}
          styles={`justify-content:flex-start;padding-left:30px`}
          title={I18n.t('restaurants&caves.pos.recap.columns.wine')}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          expander={isBranded}
          onClick={
            isBranded ? () => handleExpanded(props.viewIndex) : undefined
          }
          font="sfcompact_text"
          styles={`justify-content:flex-start;padding-left:30px;font-weight:600;`}
        >
          {props.value}
        </Cell>
      ),
      minWidth: 250
    },
    {
      Header: () => (
        <Header
          sortable={true}
          sort={() => handleSort('pdv_gagnes')}
          title={I18n.t('restaurants&caves.pos.recap.columns.won')}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          value={props.value ? '+' + props.value : props.value}
        />
      ),
      sortMethod: (a, b) => Number(a) - Number(b),
      accessor: 'pdv_gagnes'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('restaurants&caves.pos.recap.columns.lost')}
          sortable={true}
          sort={() => handleSort('pdv_perdus')}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          value={props.value ? '-' + props.value : props.value}
        />
      ),
      sortMethod: (a, b) => Number(a) - Number(b),
      accessor: 'pdv_perdus'
    }
  ];

  return (
    <>
      <Table
        data={data}
        columns={columns}
        sorted={sorted}
        expanded={expanded}
      />
      <TotalRow>
        <div className="labelPosRecapTotal">
          <p>{I18n.t('restaurants&caves.pos.recap.columns.total')}</p>
        </div>
        <p className="won">
          {total && total.pdv_gagnes ? total.pdv_gagnes : 0}
        </p>
        <p className="lost">
          {total && total.pdv_perdus ? total.pdv_perdus : 0}
        </p>
      </TotalRow>
    </>
  );
};

export default PosRecap;
